import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Card } from 'primereact/card';
import { useAuth } from '../../contexts/AuthContext';

function Login({ message }) {
  const [formValues, setFormValues] = useState({});
  const { login, user, error, setError } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  const redirectPath = location.state?.path || '/home';

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(null);
    login(formValues);
  };

  useEffect(() => {
    if (user !== null) navigate(redirectPath);
  }, [user]);

  return (
    <div className="flex align-items-center justify-content-center min-h-screen p-3">
      <div className="w-full md:w-6 lg:w-4">
        <Card title="Вход в систему" className="shadow-4">
          {error && (
            <Message severity="error" text={error} className="w-full mb-3 px-3" />
          )}
          <form onSubmit={handleSubmit}>
            <div className="flex flex-column gap-3">
              <div className="flex flex-column gap-2">
                <label htmlFor="email" className="font-medium">Email</label>
                <InputText
                  id="email"
                  name="email"
                  type="text"
                  placeholder="Введите email"
                  value={formValues?.email || ''}
                  onChange={handleInputChange}
                  className="w-full"
                />
              </div>

              <div className="flex flex-column gap-2">
                <label htmlFor="password" className="font-medium">Пароль</label>
                <InputText
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Введите пароль"
                  value={formValues?.password || ''}
                  onChange={handleInputChange}
                  className="w-full"
                />
              </div>

              <Button
                type="submit"
                label="Вход"
                icon="pi pi-sign-in"
                className="w-full mt-2"
              />
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
}

export default Login;